import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IntIteratorClass;
function IntIterator() {
  if (IntIteratorClass === VOID) {
    class $ {
      next_20eer_k$() {
        return this.nextInt_ujorgc_k$();
      }
    }
    initMetadataForClass($, 'IntIterator');
    IntIteratorClass = $;
  }
  return IntIteratorClass;
}
var LongIteratorClass;
function LongIterator() {
  if (LongIteratorClass === VOID) {
    class $ {
      next_20eer_k$() {
        return this.nextLong_njwv0v_k$();
      }
    }
    initMetadataForClass($, 'LongIterator');
    LongIteratorClass = $;
  }
  return LongIteratorClass;
}
//region block: exports
export {
  IntIterator as IntIteratordtlvcwxsuu5a,
  LongIterator as LongIterator6nf6jdg4ti4,
};
//endregion

//# sourceMappingURL=PrimitiveIterators.mjs.map
